<template>
  <div id="cubeUpload">
    <!-- <Upload
      ref="upload"
      v-model="files"
      :default-file-list="files"
      :action="uploadUrl"
      :headers="{'Authorization': $store.state.Authorization}"
      :on-success="handleOptionSuccess"
      :on-remove="fileRemoved"
      :on-error="errHandler"
      :max-size="maxSize"
      :before-upload="filesAdded"
      :accept="accept"
    >
      <Button class="uploadbtn">上传文件</Button>
    </Upload>-->
    <el-upload
      ref="upload"
      :limit="fileMax"
      :action="uploadUrl"
      :headers="{'Authorization': $store.state.Authorization,'tenant': $store.state.tenant.tenant}"
      :on-success="handleOptionSuccess"
      :simultaneousUploads="simultaneousUploads"
      @files-added="filesAdded"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :before-upload="beforeAvatarUpload"
      :file-list="files"
      list-type="picture"
    >
      <el-button size="small" type="primary">上传文件</el-button>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <div class="pdf" style="min-width:30%" v-if="fileType">
        <p class="arrow">
          <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</span>
          {{currentPage}} / {{pageCount}}
          <span
            @click="changePdfPage(1)"
            class="turn"
            :class="{grey: currentPage==pageCount}"
          >下一页</span>
        </p>

        <pdf
          :src="dialogImageUrl"
          :page="currentPage"
          @num-pages="pageCount=$event"
          @page-loaded="currentPage=$event"
          @loaded="loadPdfHandler"
        ></pdf>
      </div>
      <div style="width:30%" v-else>
        <img width="100%" :src="dialogImageUrl" @click="previewImg(dialogImageUrl)" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
import { uploadImgServer, CARINGFAST } from '../../../utils/env'
import { Message } from 'element-ui'
export default {
  props: ['item', 'newDom'],
  components: { pdf },
  data() {
    return {
      uploadUrl: uploadImgServer,
      dialogVisible: false,
      dialogImageUrl: '',
      files: [],
      fileList: [],
      simultaneousUploads: 2,
      accept: '',
      fileMax: 10,
      value: '',
      fileIndex: '',
      chooseImageData: '',
      bloc: '',
      binary: '',
      num: 0,
      successData: '',
      path: '',
      userAgent: '',
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: false,
    }
  },
  created: function () {
    // debugger
    this.userAgent = window.navigator.userAgent.toLowerCase()
    if (this.item.value.fileUploadAttribute.maxFileQuantity != '') {
      this.fileMax = Number(this.item.value.fileUploadAttribute.maxFileQuantity)
    }
    // 上传类型的更改

    if (this.item.value.fileUploadAttribute.fileType != '') {
      this.accept = this.item.value.fileUploadAttribute.fileType.join(',')
    }

    // 查看答案的默认值
    if (this.item.value.fileUploadAttribute.answer.length != 0) {
      this.item.value.fileUploadAttribute.answer.forEach((e) => {
        var file = { name: '', response: { data: '' }, url: '' }
        // var file2 = { name: '', url: '' }
        file.response.data = e.split(CARINGFAST)[1]
        file.name = file.response.data
        file.url = e
        this.files.push(file)

        console.log(this.files)
      })
    }
  },
  watch: {
    files: function () {
      this.num++
    },
  },
  methods: {
    previewImg(url) {
      this.dialogVisible = false
      this.$hevueImgPreview(url)
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },

    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },

    beforeAvatarUpload(file) {
      var fileClass = file.name.split('.')[1]
      var fileClassStatu = false
      // 判断上传的文件是否符合要求

      if (this.accept && this.accept.indexOf(',') > -1) {
        var fileNum = ''
        fileNum = this.accept.split(',')
        fileNum.forEach((item) => {
          if (item == fileClass) {
            fileClassStatu = true
          }
        })
      } else if (this.accept) {
        if (this.accept == fileClass) {
          fileClassStatu = true
        }
      } else if (this.accept === '') {
        fileClassStatu = true
      }
      if (!fileClassStatu) {
        Message.warning({
          message:
            this.item.value.fileUploadAttribute.errorMessage != ''
              ? this.item.value.fileUploadAttribute.errorMessage
              : '请上传(' + this.accept + ')类型文件',
        })
      } else {
        console.log(this.item.value.fileUploadAttribute.singleFileKBytes)
        if (
          this.item.value.fileUploadAttribute.singleFileKBytes != '' &&
          file.size / 1024 >
            Number(this.item.value.fileUploadAttribute.singleFileKBytes)
        ) {
          Message.warning({
            message:
              this.item.value.fileUploadAttribute.errorMessage != ''
                ? this.item.value.fileUploadAttribute.errorMessage
                : '上传的文件大小不得大于' +
                  this.item.value.fileUploadAttribute.singleFileKBytes,
          })
          fileClassStatu = false
        }
      }

      return fileClassStatu
    },
    createToast: function (txt) {
      this.$createToast({
        type: 'warn',
        time: 1000,
        txt: txt,
      }).show()
    },
    filesAdded(files) {
      let hasIgnore = false
      const file = files[files.length - 1]
      if (this.item.value.fileUploadAttribute.singleFileKBytes) {
        const maxSize =
          Number(this.item.value.fileUploadAttribute.singleFileKBytes) * 1024 // 1M

        if (file.size > maxSize) {
          file.ignore = true
          hasIgnore = true
        }
        if (hasIgnore === true) {
          this.createToast(
            '单个文件不得大于' +
              this.item.value.fileUploadAttribute.singleFileKBytes +
              'kb'
          )
          return
        }
      }
      // 上传文件类型

      if (this.item.value.fileUploadAttribute.fileType.length > 0) {
        const fileOptionType = this.item.value.fileUploadAttribute.fileType
        const fileName = String(file.name).split('.')[1]

        if (fileOptionType.indexOf(fileName) === -1) {
          file.ignore = true
          hasIgnore = true
        }
        if (hasIgnore === true) {
          this.createToast('上传文件类型错误')
          return
        }
      }
      // 上传文件个数
      if (this.item.value.fileUploadAttribute.maxFileQuantity) {
        if (
          this.files.length >=
          Number(this.item.value.fileUploadAttribute.maxFileQuantity)
        ) {
          file.ignore = true
          hasIgnore = true
        }
        if (hasIgnore === true) {
          this.createToast(
            '最多上传' +
              this.item.value.fileUploadAttribute.maxFileQuantity +
              '个文件'
          )
          return
        }
      }
    },

    uploadImage: function (path, index, length) {
      // 上传图片
      this.path = path
      var self = this
      var currentSrc = 'data:image/png;base64,' + path
      var $Blob = this.getBlobBydataURI(currentSrc, 'image/png')
      self.bloc = $Blob
      var formData = new FormData()
      formData.append(
        'file',
        $Blob,
        'file_' +
          new Date().getTime() +
          '_' +
          Math.random().toFixed(4) * 10000 +
          '.png'
      )
      var request = new XMLHttpRequest()
      request.open('POST', self.$store.state.uploadImgServer)
      request.setRequestHeader('Authorization', self.$store.state.Authorization)
      request.onreadystatechange = function (event) {
        // alert('success')
        if (request.readyState === 4) {
          if (request.status === 200) {
            var res = event && event.target && event.target.response
            res = JSON.parse(res)
            if (res.code === 0) {
              self.successData = res.data
              if (self.files.length >= self.fileMax) return
              self.files.push({
                name: res.data,
                response: { data: self.$store.state.fileDIR + res.data },
              })
              self.item.value.fileUploadAttribute.answer.push(
                self.$store.state.fileDIR + res.data
              )
            } else {
              self.$utils.toast({
                type: 'error',
                message: `第${index + 1}张图片上传失败：${res.message}`,
              })
            }
            if (index === length - 1) {
              setTimeout(() => {
                self.$utils.loadingHide()
              }, Math.random() * 1000)
            }
          } else {
            self.$utils.toast({
              type: 'error',
              message: `第${index + 1}张图片上传失败`,
            })
          }
        }
      }
      request.send(formData)
    },
    getBlobBydataURI: function (dataURI, type) {
      var binary = atob(dataURI.split(',')[1])
      var array = []
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      this.binary = new Blob([new Uint8Array(array)], {
        type: type,
      })
      return new Blob([new Uint8Array(array)], {
        type: type,
      })
    },

    //选项图片上传成功文件大小kb
    handleOptionSuccess: function (res, file) {
      // 上传成功之后的判断，文件大小和文件数量 this.item.value.fileUploadAttribute.errorMessage != "" ||
      if (res.code === 0) {
        //  判断上传类型

        this.item.value.fileUploadAttribute.verifyStatus = true
        this.item.value.fileUploadAttribute.answer.push(
          this.$store.state.fileDIR + res.data
        )
      } else {
        Message.warning({
          message: '上传失败',
        })
      }
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.item.value.fileUploadAttribute.answer.map((i, index) => {
        if (i.indexOf(file.response.data) != -1) {
          this.item.value.fileUploadAttribute.answer.splice(index, 1)
        }
      })
    },
    handlePreview(file) {
      console.log(file)
      if (file.name.indexOf('pdf') > -1) {
        this.fileType = true
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      } else {
        this.fileType = false
        this.dialogImageUrl = file.url
        this.$hevueImgPreview(file.url)
      }
    },
    handleExceed(files, fileList) {
      Message.warning({
        message:
          this.item.value.fileUploadAttribute.errorMessage != ''
            ? this.item.value.fileUploadAttribute.errorMessage
            : '上传的文件数量不得大于' + this.fileMax + '个',
      })
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
  },
}
</script>
<style lang="less">
#cubeUpload .uploadbtn {
  width: 100%;
  height: 33px;
  text-align: center;
  line-height: 35px;
  background-color: rgb(226, 232, 243);
  border: none;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  color: #566277;
  margin-top: 20px;
  position: relative;
}
/* 修改上传文件的样式 */
#cubeUpload .cube-upload-file {
  position: relative;
  width: 100%;
  height: 30px;
  margin-bottom: 10px;
}
#cubeUpload .cubeic-wrong {
  position: absolute;
  top: 4px;
  right: 8px;
}
#cubeUpload .cubeic-wrong:before {
  font-size: 16px;
  color: #999;
}
#cubeUpload .cube-upload-file-status.cubeic-right {
  display: none !important;
}
#cubeUpload .cube-upload-file-def {
  width: 100%;
  height: 30px;
  margin-bottom: 10px;
}
#cubeUpload .cubeic-right:before,
#cubeUpload .cubeic-right:after {
  color: transparent;
}
#cubeUpload .cube-upload-file-state.cube-upload-file_stat {
  background-color: #fff;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  margin-bottom: 5px;
  width: 100%;
  -webkit-appearance: none;
  outline: none;
}
#cubeUpload .cube-upload-file-def > .cubeic-wrong {
  position: absolute;
  z-index: 2;
  top: 7px;
  right: 8px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 7px;
  background-color: #fff;
  border-radius: 50%;
}
</style>
